/* istanbul ignore file */
export const ACCESS_TOKEN_COOKIE = 'mv-at';
export const REFRESH_TOKEN_COOKIE = 'mv-rt';
export const STATE_COOKIE = 'mv-sc';
export const NONCE_COOKIE = 'mv-nc';
export const EXCHANGE_STATE_COOKIE = 'mv-esc';
export const AUTH_STATE_COOKIE = 'mv-as';
export const SIGNEDIN_VIA_HORIZONTAL_COOKIE = 'mv-hl';
